// Verifica se o navegador suporta notificações
const isNotificationSupported = () => {
  return "Notification" in window;
};

// Verifica se é um dispositivo móvel
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

// Solicita permissão para enviar notificações
export const requestNotificationPermission = async () => {
  if (!isNotificationSupported()) {
    console.log("Este navegador não suporta notificações");
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  } catch (error) {
    console.error("Erro ao solicitar permissão:", error);
    return false;
  }
};

// Envia uma notificação local
export const sendLocalNotification = (title, options = {}) => {
  if (!isNotificationSupported()) return;

  // Se for dispositivo móvel, não envia notificação local
  if (isMobileDevice()) return;

  const defaultOptions = {
    icon: "/logoWeb.png",
    badge: "/logoWeb.png",
    ...options,
  };

  try {
    new Notification(title, defaultOptions);
  } catch (error) {
    console.error("Erro ao enviar notificação:", error);
  }
};

// Verifica se as notificações estão habilitadas
export const areNotificationsEnabled = () => {
  if (!isNotificationSupported()) return false;
  return Notification.permission === "granted";
};

// Verifica se deve usar FCM
export const shouldUseFCM = () => {
  return isMobileDevice();
};
